import type { PdfTemplate } from '../@types/PdfTemplate';
import type { Actions } from '../actions';
import {
  RCV_ADD_PDF_TEMPLATE,
  RCV_DEL_PDF_TEMPLATE,
  RCV_GET_PDF_TEMPLATE,
  REQ_ADD_PDF_TEMPLATE,
  REQ_DEL_PDF_TEMPLATE,
  REQ_GET_PDF_TEMPLATE,
  REQUEST_FAILED,
} from '../actions/pdf-template';
import { requestStatus, responseStatus } from '../shared/statuses';

interface PdfTemplateState {
  requestStatus: number;
  responseStatus: number;
  templates: PdfTemplate[] | null;
}

const _initialState: PdfTemplateState = {
  requestStatus: requestStatus.WAITING,
  responseStatus: responseStatus.OK,
  templates: null,
};

let templates = null;
const pdfTemplateReducer = (
  state: PdfTemplateState = _initialState,
  action: Actions,
): PdfTemplateState => {
  switch (action.type) {
    case REQ_GET_PDF_TEMPLATE:
      return {
        ...state,
        templates: null,
        requestStatus: requestStatus.FETCHING,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_GET_PDF_TEMPLATE:
      return {
        templates: action.response,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    case REQ_ADD_PDF_TEMPLATE:
      return {
        ...state,
        requestStatus: requestStatus.CREATING,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_ADD_PDF_TEMPLATE:
      templates = state.templates || [];
      templates.push(action.response);
      return {
        ...state,
        templates,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    case REQ_DEL_PDF_TEMPLATE:
      return {
        ...state,
        requestStatus: requestStatus.REMOVING,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_DEL_PDF_TEMPLATE:
      templates = (state.templates || []).filter((x) => x.id !== action.response.id);
      return {
        ...state,
        templates,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    case REQUEST_FAILED:
      return {
        ...state,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.FAILED,
      };
    default:
      return state;
  }
};

export default pdfTemplateReducer;
